module.exports = __webpack_public_path__ + "static/img/2016-01.306e505.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/publication/2016-01.png
// module id = AHIc
// module chunks = 6